<template>
  <div class="market">
    <!-- 搜索栏 -->
    <div class="search-bar">
      <van-search
        v-model="filterForm.categoryName"
        placeholder="搜索饰品名称"
        style="flex:1;"
      />
      <van-button size="small" type="primary" @click="search">搜索</van-button>
      <div class="search-icon" @click="showSidebarPopup = true">
        <van-icon name="filter-o" size="22" />
      </div>
    </div>
    <!-- 侧边栏弹窗 -->
    <van-popup v-model:show="showSidebarPopup" position="right" :style="{width:'70%',height:'100%'}" round>
      <div class="sidebar-form">
          <!-- 品质筛选 -->
      <van-field
      v-model="filterForm.quality"
      readonly
      name="picker"
      label="品质"
      placeholder="请选择品质"
      @click="showPicker = true"
      :clearable="true"
    />

    <van-field
      v-model="filterForm.description"
      readonly
      name="picker"
      label="赛季"
      placeholder="请选择赛季"
      @click="showSaiji = true"
      :clearable="true"
    />

    <van-field
    v-model="filterForm.template"
    clearable
    label="模板"
    placeholder="请输入模板"
  />
    

          <van-field
            v-model="filterForm.isStackLable"
            label="ST"
            placeholder="是否ST"
            readonly
            is-link
            @click="showCategoryTypesPicker = true"
          />

          <div>
            <van-button size="small" style="width: 100%;margin-bottom: 10px;" type="primary" @click="reset">重置</van-button>
            <van-button  size="small"  style="width: 100%;" type="primary" @click="search">搜索</van-button>
          </div>
          
        </div>
    </van-popup>

   <van-popup v-model:show="showPicker" position="bottom" round>
     <div class="quality-picker-container">
       
       <div class="quality-options">
         <div 
           v-for="(quality, index) in qualityColumns"
           :key="quality"
           :index="index"
           class="quality-option"
           @click="handleSelectQuality(quality)"
         >
           <div class="quality-name">{{ quality}}</div>
         </div>
       </div>
     </div>
   </van-popup>

   <van-popup v-model:show="showSaiji" position="bottom" round style="height: 60%;">
     <div class="quality-picker-container">
       <div class="quality-options">
         <div 
           v-for="(saiji, index) in saijiList"
           :key="saiji.season"
           :index="index"
           class="quality-option"
           @click="handleSelectSaiji(saiji.season)"
         >
           <div class="quality-name">{{ saiji.season}}</div>
         </div>
       </div>
     </div>
   </van-popup>

   <!-- 饰品类别多选弹出框 -->
<van-popup v-model:show="showCategoryTypesPicker" position="bottom" round>
  <div class="category-types-picker-container">
    <div 
           v-for="(stack, index) in isStackList"
           :key="index"
           :index="index"
           class="quality-option"
           @click="handleSelectStack(stack)"
         >
           <div class="quality-name">{{ stack.label}}</div>
         </div>
  </div>
</van-popup>

    <!-- 筛选标签 -->
    <div class="filter-tabs">
      <van-tabs v-model:active="activeCategory" @change="onCategoryChange">
        <van-tab
          v-for="category in categories"
          :key="category.categoryId"
          :title="category.categoryName"
        />
      </van-tabs>
    </div>

    <!-- 武器类型展示区域 -->
    <div class="weapon-types" :class="{ 'is-none':!isExpanded }">
      <div class="weapon-type-grid">
        <div 
          v-for="weaponType in categoriesChildren" 
          :key="weaponType.categoryId"
          class="weapon-type-item"
          :class="{ active: selectedWeaponType === weaponType.categoryId }"
          @click="onWeaponTypeSelect(weaponType)"
        >
          <img :src="weaponType.imageUrl" :alt="weaponType.categoryName" />
          <span class="weapon-type-name">{{ weaponType.categoryName }}</span>
        </div>
      </div>
    </div>
    <div class="pulldown">
      <van-icon name="arrow-up" size="28" class="pulldown-icon" :class="{ 'is-expanded': !isExpanded }" @click="toggleExpand"/>
    </div>

    <!-- 武器列表 -->
    <div class="section-header">
      <div class="title-box">
        <span class="title" style="">出售</span>
      </div>
    </div>
    


    <div class="weapon-grid">  
      <van-list 
      offset="50"
      scroller 
      class="list-class"
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
>
        <div 
          v-for="weapon in list" 
          :key="weapon.produceId" 
          :class="['weapon-card', { 'selected-card': restoredSelectedId && (restoredSelectedId == (weapon.produceId || weapon.productId || weapon.id)) }]"
          @click="onWeaponClick(weapon)"
        >
          <!-- 商品图片容器 -->
          <div class="weapon-image-container">
            <img :src="weapon.imageUrl" :alt="weapon.name" class="weapon-image" />
            <div class="icons-container" v-if="weapon.stickerUrls.length>0">
              <img 
                  v-for="(sticker, index) in weapon.stickerUrls.split(',')" 
                  :key="index"
                  :src="sticker" 
                  :alt="weapon.categoryName"
                  class="icon-item"
                  :title="weapon.categoryName"
                />
            </div>
            <div class="template-overlay" v-if="weapon.template > 0">
                <div class="template-wrapper">
                  <img src="@/assets/template.png" width="30px" height="30px" />
                  <span class="template">{{ weapon.template || '0' }}</span>
                </div>
              </div>
            <!-- <span class="template">{{ weapon.template || '0' }}</span> -->

          </div>
          <!-- 商品信息 -->
          <div class="weapon-info">
            <div style="color:  black;font-size: 12px;font-weight: bold;margin-bottom: 3px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis">
                {{ weapon.categoryName }}
              </div>

            <!-- 价格和统计 -->
            <div class="weapon-stats">
              <div class="price-section">
                <span style="color: #ee0a24;font-weight: bold;">￥</span>
                <span class="current-price">{{ weapon.price }} </span>
                <img v-if="weapon.isStack =='1'" src="@/assets/st.png" alt="ST" width="26px" height="16px" class="product-sales" />
              </div>
 
            </div>
          </div>
        </div>
      </van-list>
    </div>


     
     

   <div class="height-50"></div>
   <div class="height-50"></div>
    <!-- <van-tabbar route >
      <van-tabbar-item replace to="/" icon="home-o" >首页</van-tabbar-item>
      <van-tabbar-item replace to="/market"  icon="search">市场</van-tabbar-item>
      <van-tabbar-item replace to="/stock"  icon="shop-o">出售</van-tabbar-item>
      <van-tabbar-item replace to="/back"  icon="after-sale">回收</van-tabbar-item>
      <van-tabbar-item replace to="/proxyPlay"  icon="diamond-o">代充</van-tabbar-item>
      <van-tabbar-item replace to="/profile"  icon="user-o">我的</van-tabbar-item>
    </van-tabbar> -->
    <!-- 底部弹框 -->
    <van-popup
      v-model:show="showBottomPopup"
      position="top"
      :style="{ height: '40%' }"
    >
      <div class="weapon-popup-content" v-if="selectedWeaponData.length>0">
        <div
        @click="handSelectBottomPopup(item)"
         class="weapon-popup-item" v-for="(item,index) in selectedWeaponData" :key="index" :index="index"
         :class="{ activePopup: selectBottomPopup == item.categoryId }"
         >
         <img :src="item.imageUrl" :alt="item.categoryName">
          <span class="weapon-popup-name">{{ item.categoryName }}</span>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model:show="showBottomPopup2"
      position="top"
      :style="{ height: '30%' }"
    >
      <div class="weapon-popup-content" v-if="selectedWeaponData2.length>0">
        <div
        @click="handSelectBottomPopup2(item)"
         class="weapon-popup-item" v-for="(item,index) in selectedWeaponData2" :key="index" :index="index"
         :class="{ activePopup: selectBottomPopup2 == item.categoryId }"
         >
         <img :src="item.imageUrl" :alt="item.categoryName">
          <span class="weapon-popup-name">{{ item.categoryName }}</span>
        </div>
      </div>
    </van-popup>

  

   </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'MarketPage',  // 改为多词
  data() {
      return {
        isExpanded: true,
        list:[],
        total:0,
        result: '',
        showPicker: false,
        showSaiji: false,
        showCategoryPicker: false,
         showCategoryTypesPicker: false, // 新增饰品类别选择器显示状态,
         isStackList: [
           { label: '是', value: '1' },
           { label: '否', value: '0' },
         ],
        pickerValue: [],
        selectedQuality: '',
        qualityColumns: [
      
      ],
      searchValue: '',
      filterForm: {
        quality: '',
        category: '',
        st: '',
        template: '',
        name: '',
        description: '',
        price: '',
        parentId: '',
      },
      showSidebarPopup: false,
      searchQuality: '',
      searchCategory: [],
      searchStValue: '',
      searchTemplateValue: '',
     
      activeCategory: 0,
      selectedWeaponType: null,
      refreshing: false,
      loading: false,  // 初始化时设置为 true，防止立即触发加载
      finished: false,
      categories: [
      ],
      pageNum:0,
      pageSize:20,
      categoriesChildren:[],
      showBottomPopup: false,
      showBottomPopup2: false,
      selectedWeaponData: [],
      selectedWeaponData2: [],
      selectBottomPopup:null,
      selectBottomPopup2:null,
      // 武器商品数据
      weaponList: [ ],
      saijiList: [ ]
      ,
      restoredSelectedId: null
    }
  },
  created() {
    this.pageNum = 0
    let queryStr = sessionStorage.getItem('market-query')
    let isExpanded = sessionStorage.getItem('isExpanded')
    if(isExpanded == 'true'){
      this.isExpanded = true
    }
    else if(isExpanded == 'false'){
      this.isExpanded = false
    }

    if(queryStr){
     this.filterForm = JSON.parse(queryStr)
    }
    request.get('/front/weapon/season/list').then(res=>{
      if(res.code == 200){
        this.saijiList = res.data.seasonList
        // console.log(this.saijiList)
      } 
    })

      request.get('/front/weapon/quality/list').then(res=>{
        if(res.code == 200){
          this.qualityColumns = res.data.qualityList
        }
      })
      // console.log(this.finished)
  },
  computed: {
  },
  mounted() {
    
   //获取上架饰品
   request.get('/front/weapon/category').then(res=>{
        if(res.code == 200){
          this.categories = res.data.weaponCategories
          if(this.categories.length>0){
            this.categoriesChildren = this.categories[0].children
          }
        }
      })
  },
  methods: {
 hasNonEmptyValue(obj) {
      if (!obj || typeof obj !== 'object') return false;
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          if (value !== null && value !== undefined && value !== '') {
            return true;
          }
        }
      }
      return false;
    },

    toggleExpand() {
    this.isExpanded = !this.isExpanded;
    // 这里可以添加展开/收起的具体逻辑
  },
    // 上拉加载
    getList() {
      if(this.finished){
        return false
      }
      // 在请求开始前设置 loading 为 true
      // this.loading = true
      request.get('/front/weapon/list', {
        params: {
          categoryName: this.filterForm.categoryName,
          description: this.filterForm.description,
          quality: this.filterForm.quality,
          template: this.filterForm.template,
          isStack: this.filterForm.isStackValue,
          parentId: this.filterForm.parentId,
          pageNum: this.pageNum,
          pageSize: 10
        }
      }).then(res => {
        if (res.code == 200) {
          if (this.pageNum === 1) {
            this.list = res.rows
          } else {
            this.list = [...this.list, ...res.rows]
          }
          this.total = res.total
          
          // 判断是否加载完成
          this.finished = this.list.length >= res.total
          // 列表数据加载后尝试恢复滚动位置（如果存在）
          this.$nextTick(() => {
            this.restoreScrollPosition()
          })
        }else {
          this.finished = true;
        }
      })
      .catch(error => {
        this.loading = false
        this.finished = true;
      })
      .finally(() => {
        // 请求完成后再设置 loading 为 false
        this.loading = false
      })
    },
    onLoad2(){
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }

        // 加载状态结束
        this.loading2 = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished2 = true;
        }
      }, 1000);
    },
    onLoad() {
      // 如果已经加载完成或正在加载中，直接返回
      setTimeout(() => {
        this.pageNum++;
        this.getList();
      }, 500);
    },
    search(){
      this.pageNum = 1
      this.finished = false
      if(!this.filterForm.categoryName){
        this.selectedWeaponType = ''
      }
      this.getList()
    },
    reset(){
      this.filterForm = {}
      this.pageNum = 1
      this.getList()
    },

    handSelectBottomPopup(data){
      console.log(data)
      this.selectBottomPopup = data.categoryId
      this.filterForm.categoryName = data.categoryName
      this.filterForm.parentId = data.categoryId
      // if(data.children.length>0){
      //   this.showBottomPopup2 = true
      //   this.selectedWeaponData2 = data.children
      // }else{
      // this.showBottomPopup = false
      // }
      this.showBottomPopup = false
      this.search()
    },
    handSelectBottomPopup2(data){
      
      this.selectBottomPopup2 = data.categoryId
      this.filterForm.categoryName = data.categoryName
      this.search()
      this.showBottomPopup2 = false
      this.showBottomPopup = false
    },


      handleSelectQuality(v){
        this.filterForm.quality = v
        this.showPicker = false
      },
      handleSelectSaiji(v){
        this.filterForm.description = v
        this.showSaiji = false
      },
      handleSelectStack(v){
        this.filterForm.isStackLable = v.label
        this.filterForm.isStackValue = v.value
        this.showCategoryTypesPicker = false
      },
    onCategoryChange(index) {
      this.weaponList = []
      // this.finished = false
      // 获取当前选中的分类ID
      const currentCategory = this.categories[index]
      if (currentCategory.children !=null && currentCategory.children.length>0) {
        this.categoriesChildren = currentCategory.children
      }
    },
    onWeaponTypeSelect(weaponType) {
      console.log(weaponType)
      this.selectedWeaponType = weaponType.categoryId
      this.selectedWeaponData = weaponType.children
      this.filterForm.categoryName = weaponType.categoryName
      if(weaponType.categoryName.indexOf('枪')==-1){
        this.search()
      }else{
        this.showBottomPopup = true
      }
      // this.search()
      
    },

    restoreScrollPosition() {
      this.$nextTick(() => {
        const saved = sessionStorage.getItem('marketWeaponGridScrollTop')
        const savedId = sessionStorage.getItem('marketSelectedProduceId')
        if (savedId) {
          this.restoredSelectedId = String(savedId)
        }
        if (saved) {
          setTimeout(() => {
            try {
              const container = this.$el ? this.$el.querySelector('.weapon-grid') : null;
              if (container) {
                container.scrollTop = parseInt(saved);
              }
            } catch (e) {
              console.warn('恢复 market 滚动位置失败', e);
            }
          }, 200);
        }
      })
    },

    onWeaponClick(weapon) {
      // 保存 UI 状态
      sessionStorage.setItem('isExpanded', this.isExpanded+"")
      if(this.hasNonEmptyValue(this.filterForm)){
        sessionStorage.setItem('market-query', JSON.stringify(this.filterForm))
      }else{
        sessionStorage.removeItem('market-query')
      }

      // 保存当前列表滚动位置和选中项 id，以便返回时恢复
      try {
        const container = this.$el ? this.$el.querySelector('.weapon-grid') : null;
        if (container) {
          sessionStorage.setItem('marketWeaponGridScrollTop', String(container.scrollTop || 0));
        }
        const id = weapon.produceId || weapon.productId || weapon.id || '';
        if (id) sessionStorage.setItem('marketSelectedProduceId', String(id));
      } catch (e) {
        console.warn('保存 market 滚动位置失败', e);
      }

      // 跳转到武器详情页
      this.$router.push({
        path: '/weapon/' + new Date().getTime(), 
        query: {
          produceId: weapon.productId || weapon.produceId,
        },
      })
    }
  
  }
}
</script>

<style scoped>
.market {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 设置整个页面高度 */
}
.search-bar {
  background: white;
  padding: 10px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;
}
.search-icon {
  margin-left: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar-form {
  padding: 18px 10px 10px 10px;
}
.form-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 18px;
  padding: 18px 14px 12px 14px;
}
.form-title {
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 12px;
  color: #323233;
}

/* 品质选项样式 */
.quality-option {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.quality-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  margin-right: 8px;
  border: 1px solid #eee;
}

.quality-text {
  font-size: 14px;
  color: #323233;
}
.form-card .van-checkbox-group {
    padding: 4px 0 0 0;
  }

  /* 品质选择器样式 */
  .quality-option {
    display: flex;
    align-items: center;
    padding: 10px;
  }

  .quality-color {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    margin-right: 10px;
    border: 1px solid #eee;
  }

  .quality-text {
    font-size: 14px;
    color: #323233;
  }
.form-sub-field {
  margin-top: 12px;
}
.form-card .van-field {
  width: 100%;
  margin-top: 0;
}
.filter-tabs {
  background: white;
  margin-bottom: 5px;
  height: 44px; /* 添加固定高度 */
  min-height: 44px; /* 确保最小高度 */
}

/* 标题区域 */
.section-header {
  display: flex;
  /* justify-content: space-between;
  align-items: center; */
  margin-top: 0px;
  margin-bottom: 10px;
  flex-shrink: 0; /* 防止标题区域被压缩 */
}

.section-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #323233;
}

.title-box {
  padding-left: 10px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  position: relative;
  display: inline-block;
  padding-bottom: 8px;
}

.title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #1890ff, #40a9ff);
  border-radius: 1px;
}

.weapon-grid {
  /* 武器网格布局 */
  flex: 1;
  padding: 0 10px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto; /* 改为 auto */
  height: calc(100vh - 44px - 200px - 50px); 
  -webkit-overflow-scrolling: touch; /* 增加弹性滚动 */
}

.list-class{
  padding: 0 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}


.weapon-item img {
  width: 100%;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 8px;
}

.weapon-details h4 {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #323233;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.condition {
  margin: 0 0 5px 0;
  font-size: 12px;
  color: #969799;
}

.price {
  margin: 0;
  font-size: 16px;
  color: #ee0a24;
  font-weight: bold;
}
.weapon-types {
  background: white;
  padding: 5px 10px 5px 10px;
  overflow-y: scroll;
  height: 200px;
  transition: all 0.4s ease;
}

.pulldown {
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.pulldown-icon {
  color: #666;
  transition: all 0.3s ease;
}

.pulldown-icon.is-expanded {
  transform: rotate(180deg);
}

.weapon-types.is-none {
  height: 0;
  pointer-events: none;
}

.pulldown:active .pulldown-icon {
  opacity: 0.7;
}

.weapon-type-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.weapon-type-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #f7f8fa;
  transition: all 0.3s;
  cursor: pointer;
  border: 2px solid transparent;
}

.weapon-type-item:hover {
  background: #e8f3ff;
}

.weapon-type-item.active {
  background: #e8f3ff;
  border-color: #1989fa;
}

.weapon-type-item img {
  width: 50px;
  height: 35px;
  object-fit: contain;
  margin-bottom: 8px;
  border-radius: 4px;
}

.weapon-type-name {
  font-size: 12px;
  color: #323233;
  text-align: center;
  font-weight: 500;
}

.weapon-type-item.active .weapon-type-name {
  color: #1989fa;
}

.selected-card {
  box-shadow: 0 0 0 2px rgba(25,137,250,0.2);
  border-radius: 8px;
  transform: translateY(-2px);
}



/* 图片容器 */
.weapon-image-container {
  position: relative;
  width: 100%;
  height: 80px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.weapon-image {
  width: 90%;
  height: 70%;
  object-fit: contain;
}

/* 武器卡片 */
.weapon-card {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  margin-bottom: 8px;
  height: 130px;
  width: 48%;
}

.weapon-card:active {
  transform: scale(0.98);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 武器信息区域 */
.weapon-info {
  padding: 8px;
}

/* 价格和统计区域 */
.weapon-stats {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

/* 价格区域 */
.price-section {
  display: flex;
  /* flex-direction: column; */
  width: 100%;
}

.current-price {
  font-size: 14px;
  font-weight: 600;
  color: #ee0a24;
  flex: 1;
}

/* 统计信息 */
.stats {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
/* 品质选择器样式 */
.quality-picker-container {
  padding-bottom: 20px;
}

.quality-options {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.quality-option {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.quality-selected {
  background-color: #f2f3f5;
  border-left: 3px solid #1989fa;
}

.quality-color {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  margin-right: 12px;
  border: 1px solid #dcdfe6;
}

.quality-name {
  font-size: 14px;
  color: #323233;
}

.weapon-popup-content {
  padding: 16px;
}

.weapon-popup-item {
  display: flex;
  align-items: center;
  padding: 10px;
  background: #f7f8fa;
  border-radius: 8px;
}

.weapon-popup-item img {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-right: 12px;
}

.weapon-popup-name {
  font-size: 16px;
  color: #323233;
  flex: 1;
}


.activePopup {
  background: #e8f3ff;
  border-color: #1989fa;
}

.template-overlay {
  position: absolute;
  bottom: 5px;
  left: 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

.template-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.template {
  position: absolute;
  left: 42%;
  top: 70%;
  transform: translate(-50%, -50%);
  color: #eee;
  font-size: 12px;
  font-weight: bold;
  text-shadow: 0 0 2px rgba(0,0,0,0.5);
}

.product-sales {
  margin-left: auto;
}

.list-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* 增加 iOS 滚动流畅度 */
}
/* 左下角图标容器 */
.icons-container {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  gap: 5px;
}

.icon-item {
  width: 16px;
  height: 16px;
  /* background-color: rgba(0, 0, 0, 0.1); */
  /* border-radius: 50%; */
  object-fit: cover;
}
</style>
